import { IFetchMaintenanceStampDataProps } from "../models/formRelease";
import ApiService from "../services/api";

export const fetchMaintenanceStampData = async (scheduleUuid: string, body: IFetchMaintenanceStampDataProps): Promise<any> => {
  const apiService = new ApiService();
  const url = `/vehicle-checkup/${scheduleUuid}/occurrence-info`;

  try {
    const response = await apiService.patch<any>(url, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return true;

  } catch (error) {
    console.error("Erro ao criar nova solicitação:", error);
    return null;
  }
};